import { DLGetSettings } from './../DL/Settings'

//Funciones comunes
import { LogErrors } from './../LogErrors'
import { UpdateSessionInfo } from './Sessions'



//--- COMUNES ---//

// const ChangeTheme = async (idTheme = null) => {
//   try {
//     debugger
//     const theme = idTheme

//     if (!theme || isNaN(theme)) {
//         theme = 0
//         document.body.classList.remove('DarkTheme')
//     } else {
//       if (theme === 1) { //Dark
//         document.body.classList.add('DarkTheme')
//       } else { // Light
//         theme = 0
//         document.body.classList.remove('DarkTheme')
//       }
//     }

//     return { success: true, data: theme }
//   } catch (error) {
//     await LogErrors('ChangeTheme - BL Settings', error)
//   }
// }

const ChangeTheme = async (idTheme = null) => {
  try {
    // Validar que sea un número válido, si no, asignar 1 (tema predeterminado)
    let theme = Number.isInteger(idTheme) ? idTheme : 1

    // Aplicar o quitar la clase según el tema seleccionado
    document.body.classList.toggle('DarkTheme', theme === 2)

    return { success: true, data: theme }
  } catch (error) {
    await LogErrors('ChangeTheme - BL Settings', error)
    return { success: false, message: '' } // Retorno explícito en caso de error
  }
}

// const ChangeFontSize = async (idFontSize = null) => {
//   try {
//     let fontSize = idFontSize

//     if (!fontSize || isNaN(fontSize)) {
//       fontSize = 1 // Normal
//       document.body.classList.remove('SmallFont')
//       document.body.classList.remove('BigFont')
//     } else {
//       switch (fontSize) {
//         case 0: //Small
//           document.body.classList.remove('BigFont')
//           document.body.classList.add('SmallFont')
//           break
  
//         case 2: //Big
//           document.body.classList.remove('SmallFont')
//           document.body.classList.add('BigFont')
//           break
  
//         default: //Normal
//           fontSize = 1
//           document.body.classList.remove('SmallFont')
//           document.body.classList.remove('BigFont')
//           break
//       }
//     }

//     return { success: true, data: fontSize }
//   } catch (error) {
//     await LogErrors('ChangeFontSize - BL Settings', error)
//   }
// }

const ChangeFontSize = async (idFontSize = null) => {
  try {
    // Validar que sea un número válido, si no, asignar 1 (tamaño normal)
    const fontSize = Number.isInteger(idFontSize) ? idFontSize : 1

    // Remover todas las clases antes de aplicar la nueva
    document.body.classList.remove('SmallFont', 'BigFont')

    // Aplicar la clase correspondiente
    if (fontSize === 0) {
      document.body.classList.add('SmallFont')
    } else if (fontSize === 2) {
      document.body.classList.add('BigFont')
    }

    return { success: true, data: fontSize }
  } catch (error) {
    await LogErrors('ChangeFontSize - BL Settings', error)
    return { success: false, message: '' } // Retorno explícito en caso de error
  }
}

// const SaveWebTheme = async (themeToSave) => {
//   try {
//     let theme = null
    
//     switch (themeToSave.toLowerCase()) {
//       case 'light':
//         theme = 0
//         break
//       case 'dark':
//         theme = 1
//         break
//       default:
//         theme = 0
//         break
//     }

//     if (theme === null) {
//       return { success: false, message: '' } //Mensaje de que ese tipo de tema no existe
//     }

//     //Validar que exista la info del usuario en el session storage
//     if (!sessionStorage.getItem('userData')) {
//         return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//     }
    
//     //Obtener la info del usuario desde el session storage
//     const userData = JSON.parse(sessionStorage.getItem('userData'))

//     //Comprobar varias propiedades para ver si está correcta la info del usuario
//     if (userData.user === undefined) {
//       return { success: false, message: '' } //Mensaje indicando que no existe la llave en donde se colocará el idioma
//     }
    
//     //userData.user.theme = themeToSave
//     userData.user.theme = theme
    
//     const response = await UpdateSessionInfo(userData)
    
//     if (response.success) {
//       if (theme === 0) {
//         document.body.classList.remove('DarkTheme')
//       } else if (theme === 1) {
//         document.body.classList.add('DarkTheme')
//       }

//       //Agregar llamado a la API para guardar el tema

//       return { success: true, data: themeToSave }
//     } else {
//         return { success: false, message: response.message }
//     }
//   } catch (error) {
//     await LogErrors('SaveWebTheme - Settings BL', error)
//     return { success: false, message: '' }
//   }
// }

const SaveWebTheme = async (idTheme) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
        return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    if (userData.user === undefined) {
      return { success: false, message: '' } //Mensaje indicando que no existe la llave en donde se colocará el idioma
    }
    
    userData.user.theme = idTheme
    
    const response = await UpdateSessionInfo(userData)
    
    if (response.success) {
      await ChangeTheme(idTheme)

      //Agregar llamado a la API para guardar el tema

      return { success: true, data: idTheme }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SaveWebTheme - Settings BL', error)
    return { success: false, message: '' }
  }
}

// const SaveWebFontSize = async (fontSizeToSave) => {
//   try {
//     let fontSize = null
    
//     switch (fontSizeToSave.toLowerCase()) {
//       case 'smallfont':
//         fontSize = 0
//         break
//       case 'mediumfont':
//         fontSize = 1
//         break
//       case 'bigfont':
//         fontSize = 2
//         break
//     }

//     if (fontSize === null) {
//       return { success: false, message: '' } //Mensaje de que ese tipo de tema no existe
//     }

//     //Validar que exista la info del usuario en el session storage
//     if (!sessionStorage.getItem('userData')) {
//         return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//     }
    
//     //Obtener la info del usuario desde el session storage
//     const userData = JSON.parse(sessionStorage.getItem('userData'))

//     //Comprobar varias propiedades para ver si está correcta la info del usuario
//     if (userData.user === undefined) {
//       return { success: false, message: '' } //Mensaje indicando que no existe la llave en donde se colocará el idioma
//     }

//     userData.user.fontSize = fontSizeToSave
    
//     const response = await UpdateSessionInfo(userData)

//     if (response.success) {
//       if (fontSize === 0) {
//         //document.body.classList.remove('MediumFont')
//         document.body.classList.remove('BigFont')
//         document.body.classList.add('SmallFont')
//       } else if (fontSize === 1) {
//         document.body.classList.remove('SmallFont')
//         //document.body.classList.remove('MediumFont')
//         document.body.classList.remove('BigFont')
//       } else if (fontSize === 2) {
//         document.body.classList.remove('SmallFont')
//         //document.body.classList.remove('MediumFont')
//         document.body.classList.add('BigFont')
//       }

//       //Agregar llamado a la API para guardar el tamaño de fuente

//       return { success: true }
//     } else {
//         return { success: false, message: response.message }
//     }
//   } catch (error) {
//     await LogErrors('SaveWebFontSize - Settings BL', error)
//     return { success: false, message: '' }
//   }
// }

const SaveWebFontSize = async (idFontSize) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
        return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    if (userData.user === undefined) {
      return { success: false, message: '' } //Mensaje indicando que no existe la llave en donde se colocará el idioma
    }

    userData.user.fontSize = idFontSize
    
    const response = await UpdateSessionInfo(userData)

    if (response.success) {
      await ChangeFontSize(idFontSize)

      //Agregar llamado a la API para guardar el tamaño de fuente

      return { success: true, data: idFontSize }
    } else {
        return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SaveWebFontSize - Settings BL', error)
    return { success: false, message: '' }
  }
}

//--- Funciones para establecer el tema de Gobierno a la web ---//
const SetRiactivosTheme = async () => {
  try {
    document.body.classList.remove('MexicoTheme')
  } catch (error) {
    await LogErrors('SetRiactivosTheme - BL Settings', error)
  }
}

const SetMexicoTheme = async () => {
  try {
    document.body.classList.add('MexicoTheme')
  } catch (error) {
    await LogErrors('SetMexicoTheme - BL Settings', error)
  }
}
//--- Funciones para establecer el tema de Gobierno a la web ---//

//--- COMUNES ---//



//--- Página DASHBOARD ---//

const SetDefaultWebTheme = async () => {
  try {
    SetMexicoTheme()
    
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }
    
    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    
    //Comprobar varias propiedades para ver si está correcta la info del usuario
    const theme = userData?.user?.theme
    
    const response = await ChangeTheme(theme)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('SetDefaultWebTheme - Settings BL', error)
    return { success: false, message: '' }
  }
}

//--- Página DASHBOARD ---//

// /**
//  * Función que establece el examen Demo como finalizado
//  * @param {integer} idExam
//  * @returns boolean || null
//  */
// const SetFinishedExam = (idExam) => {
//   try {
//     //Validar que exista la info del usuario en el session storage
//     if (!sessionStorage.getItem('userData')) {
//         return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//     }
    
//     //Obtener la info del usuario desde el session storage
//     const userData = JSON.parse(sessionStorage.getItem('userData'))





//     const settings = DLGetSettings() // Esperar a que getSettings termine
    
//     if (typeOfExam.toUpperCase() === 'A') {
//       if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null)) {
//         return null
//       }
//       settings.exams.academic.demo.finished = true
//     } else if (typeOfExam.toUpperCase() === 'P') {
//       if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null)) {
//         return null
//       }
//       settings.exams.psychosocial.demo.finished = true
//     } else if (typeOfExam.toUpperCase() === 'V') {
//       if (settings === null || (settings.exams.vocational.demo === undefined || settings.exams.vocational.demo === null)) {
//         return null
//       }
//       settings.exams.vocational.demo.finished = true
//     } else {
//       return null
//     }

//     //Agregar fecha de completado
//     sessionStorage.setItem('settings',JSON.stringify(settings))

//     return true
//   } catch (error) {
//     console.log(error)
//   }
// }

// /**
//  * Función que establece y guarda el número de segundos que le quedan del examen Real
//  * @param {Date} currentTime
//  * @param {integer} idExam
//  * @returns string
//  */
// const SetRemainingExamTime = (currentTime, idExam) => {
//   try {
//     const settings = DLGetSettings() // Esperar a que getSettings termine
    
//     if (typeOfExam.toUpperCase() === 'A') {
//       if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null)) {
//         return null
//       }
//       settings.exams.academic.exam.time = String(currentTime)
//     } else if (typeOfExam.toUpperCase() === 'P') {
//       if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null)) {
//         return null
//       }
//       settings.exams.psychosocial.exam.time = String(currentTime)
//     } else if (typeOfExam.toUpperCase() === 'V') {
//       if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null)) {
//         return null
//       }
//       settings.exams.vocational.exam.time = String(currentTime)
//     } else {
//       return null
//     }

//     //Actualizar tiempo del examen
//     //settings.exam.time = String(currentTime)
//     sessionStorage.setItem('settings',JSON.stringify(settings))

//     return true
//   } catch (error) {
//     console.log(error)
//   }
// }

























































/**
 * Función para obtener las configuraciones de la plataforma
 * @param {string} language 
 * @param {boolean} isLoginPage 
 * @returns 
 */
const GetSettings = async (language = null, isLoginPage = false) => {
    try {
      const settings = await DLGetSettings(language, isLoginPage) // Esperar a que getSettings termine

      if (settings === null) {
        return null
      }
      
      return settings
    } catch (error) {
      console.log(error)
    }
}





const GetMenu = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.menu === undefined || settings.menu === null)) {
      return null
    }

    return settings.menu
  } catch (error) {
    console.log(error)
  }
}





const GetMessages = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (settings === null || (settings.messages === undefined || settings.messages === null)) {
      return null
    }

    return settings.messages
  } catch (error) {
    console.log(error)
  }
}




/**
 * Función que obtiene el tema de las configuraciones del usuario
 * @returns array
 */
const GetTheme = () => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.theme === undefined || settings.theme === null)) {
      return null
    }

    return settings.theme
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece el nuevo tema en las configuraciones del usuario
 * @param {string} $theme 
 * @returns boolean
 */
const SetTheme = ($theme) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (settings === null || (settings.theme === undefined || settings.theme === null)) {
      return null
    }

    if ($theme === null || $theme === '' || ($theme.toLowerCase() !== 'dark' && $theme.toLowerCase() !== 'light')) {
      return false
    }

    settings.theme = $theme.toLowerCase()
    sessionStorage.setItem('settings',JSON.stringify(settings))
    return true
  } catch (error) {
    console.log(error)
  }
}




/**
 * Función que obtiene la info del examen Demo
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns Array || null
 */
const GetDemoExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine

    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null)) {
        return null
      }
      return settings.exams.academic.demo
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null)) {
        return null
      }
      return settings.exams.psychosocial.demo
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null)) {
        return null
      }
      return settings.exams.academic.demo
    } else {
      return null
    }
  } catch (error) {
    console.log(error)
  }
}

// if (typeOfExam === 'A') {
    
// } else if (typeOfExam === 'P') {

// } else if (typeOfExam === 'V') {

// } else {
//   return null
// }

/**
 * Función que obtiene la info del examen Demo en caso de ya haberse finalizado
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns Array || null
 */
const GetOptionFinishedOfDemoExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    let exam

    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null) || (settings.exams.academic.demo.finished === undefined || settings.exams.academic.demo.finished === null)) {
        return null
      }
      exam = settings.exams.academic
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null) || (settings.exams.psychosocial.demo.finished === undefined || settings.exams.psychosocial.demo.finished === null)) {
        return null
      }
      exam = settings.exams.psychosocial
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.demo === undefined || settings.exams.vocational.demo === null) || (settings.exams.vocational.demo.finished === undefined || settings.exams.vocational.demo.finished === null)) {
        return null
      }
      exam = settings.exams.vocational
    } else {
      return null
    }

    const Data = {
      "title" : exam.title,
      "name" : exam.demo.name,
      "finished" : exam.demo.finished,
      "dueDate" : exam.demo.dueDate,
      "completionDate" : exam.demo.completionDate
    }

    return Data
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece el examen Demo como finalizado
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns boolean || null
 */
const SetFinishedDemoExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null)) {
        return null
      }
      settings.exams.academic.demo.finished = true
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null)) {
        return null
      }
      settings.exams.psychosocial.demo.finished = true
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.demo === undefined || settings.exams.vocational.demo === null)) {
        return null
      }
      settings.exams.vocational.demo.finished = true
    } else {
      return null
    }

    //Agregar fecha de completado
    sessionStorage.setItem('settings',JSON.stringify(settings))

    return true
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que obtiene la info del examen Real
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns Array || null
 */
const GetExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null)) {
        return null
      }
      return settings.exams.academic.exam
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null)) {
        return null
      }
      return settings.exams.psychosocial.exam
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null)) {
        return null
      }
      return settings.exams.vocational.exam
    } else {
      return null
    }
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que obtiene la info del examen Real en caso de ya haberse finalizado
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns Array || null
 */
const GetOptionFinishedOfExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    let exam

    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null) || (settings.exams.academic.exam.finished === undefined || settings.exams.academic.exam.finished === null)) {
        return null
      }
      exam = settings.exams.academic.exam
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null) || (settings.exams.psychosocial.exam.finished === undefined || settings.exams.psychosocial.exam.finished === null)) {
        return null
      }
      exam = settings.exams.psychosocial.exam
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null) || (settings.exams.vocational.exam.finished === undefined || settings.exams.vocational.exam.finished === null)) {
        return null
      }
      exam = settings.exams.vocational.exam
    } else {
      return null
    }

    const Data = {
      "name" : exam.name,
      "finished" : exam.finished,
      "dueDate" : exam.dueDate,
      "completionDate" : exam.completionDate
    }

    return Data
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece el examen Real como finalizado
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns boolean || null
 */
const SetFinishedExam = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null)) {
        return null
      }
      settings.exams.academic.exam.finished = true
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null)) {
        return null
      }
      settings.exams.psychosocial.exam.finished = true
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null)) {
        return null
      }
      settings.exams.vocational.exam.finished = true
    } else {
      return null
    }

    //Agregar fecha de completado
    sessionStorage.setItem('settings',JSON.stringify(settings))

    return true
  } catch (error) {
    console.log(error)
  }
}






//Evaluator - Timer
/**
 * Función que devuelve una cadena con el número de segundos que le quedan del examen Real
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns string
 */
const GetExamTime = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    let exam
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null) || (settings.exams.academic.exam.time === undefined || settings.exams.academic.exam.time === null)) {
        return null
      }
      exam = settings.exams.academic.exam
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null) || (settings.exams.psychosocial.exam.time === undefined || settings.exams.psychosocial.exam.time === null)) {
        return null
      }
      exam = settings.exams.psychosocial.exam
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null) || (settings.exams.vocational.exam.time === undefined || settings.exams.vocational.exam.time === null)) {
        return null
      }
      exam = settings.exams.vocational.exam
    } else {
      return null
    }

    return exam.time
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que devuelve una cadena con el número de segundos que le quedan del examen Demo
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns string
 */
const GetDemoTime = (typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    let exam

    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null) || (settings.exams.academic.demo.time === undefined || settings.exams.academic.demo.time === null)) {
        return null
      }
      exam = settings.exams.academic.demo
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null) || (settings.exams.psychosocial.demo.time === undefined || settings.exams.psychosocial.demo.time === null)) {
        return null
      }
      exam = settings.exams.psychosocial.demo
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.demo === undefined || settings.exams.vocational.demo === null) || (settings.exams.vocational.demo.time === undefined || settings.exams.vocational.demo.time === null)) {
        return null
      }
      exam = settings.exams.vocational.demo
    } else {
      return null
    }

    return exam.time
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece y guarda el número de segundos que le quedan del examen Real
 * @param {Date} currentTime
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns string
 */
const SetRemainingExamTime = (currentTime, typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.exam === undefined || settings.exams.academic.exam === null)) {
        return null
      }
      settings.exams.academic.exam.time = String(currentTime)
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.exam === undefined || settings.exams.psychosocial.exam === null)) {
        return null
      }
      settings.exams.psychosocial.exam.time = String(currentTime)
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.exam === undefined || settings.exams.vocational.exam === null)) {
        return null
      }
      settings.exams.vocational.exam.time = String(currentTime)
    } else {
      return null
    }

    //Actualizar tiempo del examen
    //settings.exam.time = String(currentTime)
    sessionStorage.setItem('settings',JSON.stringify(settings))

    return true
  } catch (error) {
    console.log(error)
  }
}

/**
 * Función que establece y guarda el número de segundos que le quedan del examen Demo
 * @param {Date} currentTime
 * @param {string} typeOfExam A = Academic, P = Psychosocial o V = Vocational
 * @returns string
 */
const SetRemainingDemoTime = (currentTime, typeOfExam) => {
  try {
    const settings = DLGetSettings() // Esperar a que getSettings termine
    
    if (typeOfExam.toUpperCase() === 'A') {
      if (settings === null || (settings.exams.academic.demo === undefined || settings.exams.academic.demo === null)) {
        return null
      }
      settings.exams.academic.demo.time = String(currentTime)
    } else if (typeOfExam.toUpperCase() === 'P') {
      if (settings === null || (settings.exams.psychosocial.demo === undefined || settings.exams.psychosocial.demo === null)) {
        return null
      }
      settings.exams.psychosocial.demo.time = String(currentTime)
    } else if (typeOfExam.toUpperCase() === 'V') {
      if (settings === null || (settings.exams.vocational.demo === undefined || settings.exams.vocational.demo === null)) {
        return null
      }
      settings.exams.vocational.demo.time = String(currentTime)
    } else {
      return null
    }

    //Actualizar tiempo del examen
    //settings.demo.time = String(currentTime)
    sessionStorage.setItem('settings',JSON.stringify(settings))

    return true
  } catch (error) {
    console.log(error)
  }
}

export { ChangeTheme, ChangeFontSize, SetMexicoTheme, SetDefaultWebTheme, SaveWebTheme, SaveWebFontSize, GetSettings, GetMenu, GetMessages, GetTheme, SetTheme, GetDemoExam, GetOptionFinishedOfDemoExam, SetFinishedDemoExam, GetExam, GetOptionFinishedOfExam, SetFinishedExam, GetExamTime, GetDemoTime, SetRemainingExamTime, SetRemainingDemoTime };